import { GET_USER_SOCIAL_REASONS, GET_SOCIAL_REASON_DETAIL, UPDATE_SOCIAL_REASON, CREATE_SOCIAL_REASON, DELETE_SOCIAL_REASON, GET_ERRORS } from '../../../../actions/types';
import { getSocialReasons, getSocialReasonById, updateSocialReason, createSocialReason, deleteSocialReason } from '../../../../actions/AddressManagementActions';
import BootstrapTable from 'react-bootstrap-table-next';
import { Edit, Visibility } from '@material-ui/icons';
import DeliveryAddresses from './DeliveryAddresses';
import SocialReasonModal from './SocialReasonModal';
import LoadingOverlay from 'react-loading-overlay';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Col, Row } from 'react-bootstrap';
import Card from '@material-ui/core/Card';
import React, { Component } from 'react';
import { IconButton } from 'material-ui';
import { connect } from 'react-redux';

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class SocialReasons extends Component {

    state = {
        socialReasonModalIsVisible: false,
        showDeliveryAddresses:      false,
        showSnackBar:               false,
        activeLoader:               true,
		severitySnackBar:           '',
		textSnackBar:               '',
        modalType:                  'CREATE',
        socialReasons:              [],
        userSelected:               this.props.userData,
        socialReasonSelected:       {},
    }

    constructor(props) {
        super(props);
        this.updateSocialReason = this.updateSocialReason.bind(this);
        this.createSocialReason = this.createSocialReason.bind(this);
        this.deleteSocialReason = this.deleteSocialReason.bind(this);
        this.handleCloseAlert   = this.handleCloseAlert.bind(this);
        this.openModalCreate    = this.openModalCreate.bind(this);
        this.onPressCancel      = this.onPressCancel.bind(this);
    }

    componentDidMount() {
        this.props.getSocialReasons(this.state.userSelected._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.socialReasons !== this.state.socialReasons) {
			this.setState({
				socialReasons: this.props.socialReasons,
				activeLoader:  false,
			});
		} else if (this.props.actionType === GET_SOCIAL_REASON_DETAIL && prevProps.actionType !== GET_SOCIAL_REASON_DETAIL) {
            this.setState({
                socialReasonSelected:       this.props.socialReasonDetailData,
                socialReasonModalIsVisible: true,
                modalType:                  'UPDATE'
            });
        } else if (this.props.actionType === UPDATE_SOCIAL_REASON && prevProps.actionType !== UPDATE_SOCIAL_REASON) {
            this.setState({
                activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Razón social actualizada exitosamente.',
				severitySnackBar: 'success',
			});
            this.props.getSocialReasons(this.state.userSelected._id);
        } else if (this.props.actionType === CREATE_SOCIAL_REASON && prevProps.actionType !== CREATE_SOCIAL_REASON) {
            this.setState({
                activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Razón social creada exitosamente.',
				severitySnackBar: 'success',
			});
            this.props.getSocialReasons(this.state.userSelected._id);
        } else if (this.props.actionType === DELETE_SOCIAL_REASON && prevProps.actionType !== DELETE_SOCIAL_REASON) {
            this.setState({
                activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Razón social eliminada exitosamente.',
				severitySnackBar: 'success',
			});
            this.props.getSocialReasons(this.state.userSelected._id);
		} else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     this.props.error,
				severitySnackBar: 'error'
			});
		}
    }

    linkActions = (cell, row, rowIndex, formatExtraData) => {
        return ([
            <Row key={rowIndex}>
                <Col xs={12} md={12} sm={12} lg={12}>
                    <IconButton size="small" style={{color:"orange"}}>
						<Edit
							key={row._id}
							onClick={() => {
                                this.getSocialReasonDetailData(row);
							}}
						/>
					</IconButton>
                    <IconButton size="small"  style={{color:"brown"}}>
						<Visibility
							key={row._id + '_view'}
							onClick={() => {
								this.setState({
									showDeliveryAddresses: true,
									socialReasonSelected:  row
								});
							}}
						/>
					</IconButton>
                </Col>
            </Row>
        ]);
    }

    ///---------------------------------------EVENTS-------------------------------------
    
    onPressReturnUD() {
        this.props.onPressReturnUD();
    }
    
    onPressReturnToSocialReasons = () => {
        this.setState({
            showDeliveryAddresses: false,
			socialReasonSelected:  null
		});
	};
    
    handleCloseAlert = (event, reason) => {
        if (reason === "clickaway") {
            return;
		}
        
		this.setState({
            showSnackBar: false,
		});
	};

    onPressCancel = () => {
		this.setState({
			socialReasonModalIsVisible: false,
			socialReasonSelected:       {}
		})
		this.props.getSocialReasons(this.state.userSelected._id);
	}

    getSocialReasonDetailData(data) {
        this.props.getSocialReasonById(data._id);
    }

    openModalCreate = () => {
		this.setState({
			socialReasonModalIsVisible: true,
			modalType:                  'CREATE',
		});
	};

    updateSocialReason(data) {
        this.props.updateSocialReason(data);
		this.setState({
            activeLoader:               true,
			socialReasonModalIsVisible: false,
            socialReasonSelected:       {}
		});
    }

    createSocialReason(data) {
        this.props.createSocialReason(this.state.userSelected.email, data.innerBranchId, data.numeroMyBusiness, data.numeroSap);
		this.setState({
            activeLoader:               true,
			socialReasonModalIsVisible: false,
            socialReasonSelected:       {}
		});
    }

    deleteSocialReason(_id) {
        this.props.deleteSocialReason(_id);
		this.setState({
            activeLoader:               true,
			socialReasonModalIsVisible: false,
            socialReasonSelected:       {}
		});
    }
    
    ///---------------------------------------VIEW-------------------------------------

    render() {
        const customOptions = {
			noDataText:
				'<div className="color-red">No hay datos disponibles para su consulta.</div>',
		};
        const columns = [
            {
                dataField: '_id',
                text:      'ID',
                classes:   'table-cell'
            },
            {
                dataField: 'nombre',
				text:      'Nombre'
			},
            {
                dataField: 'rfc',
                text:      'RFC',
            },
            {
                dataField: 'usuarioMb',
                text:      'Usuario MB',
            },
            {
                dataField: 'usuarioSAP',
                text:      'Usuario SAP',
            },
            {
                dataField: 'listaPrecioMB',
                text:      'Lista de precios MB',
            },
            {
                dataField: 'status',
                text:      'Estatus',
                headerStyle: () => {
                    return { width: "10%" };
                },
                formatter: (cell) => {
                    switch (cell) {
                        case 'SYNCING':
                            return "Por sincronizar";
                        case 'SYNCRONIZED':
                            return "Sincronizado";
                        case 'DATA_NOT_FOUND':
                            return "Sin datos en POS"
                        default:
                            return cell;
                    }
                }
            },
            {
				dataField: 'actions',
				text:      'Acciones',
				formatter: this.linkActions,
			}
        ]
        return (
            <div className="main-content">
                { this.state.showDeliveryAddresses &&
					<div>
						<DeliveryAddresses socialReasonData={this.state.socialReasonSelected} onPressReturnToSocialReasons={this.onPressReturnToSocialReasons} />
					</div>
                }
                { !this.state.showDeliveryAddresses &&
                    <center>
                        <div>
                            <LoadingOverlay
                                active={this.state.activeLoader}
                                isVisible={this.state.activeLoader}
                                spinner
                                text="Esto puede tardar unos minutos"
                                styles={{
                                    wrapper: {
                                        width: this.state.activeLoader ? "100%" : "0%",
                                        height: this.state.activeLoader ? "100%" : "0%",
                                    },
                                    overlay: (base) => ({
                                        ...base,
                                        background: "rgba(10, 10, 10, 0.7)",
                                    }),
                                }}
                            ></LoadingOverlay>
                            { this.state.socialReasonModalIsVisible &&
                                <SocialReasonModal
                                    updateSocialReason = { this.updateSocialReason }
                                    createSocialReason = { this.createSocialReason }
                                    deleteSocialReason = { this.deleteSocialReason }
                                    socialReasonData   = { this.state.socialReasonSelected }
                                    onPressCancel      = { this.onPressCancel }
                                    centers            = { this.props.centros.centros }
                                    type               = { this.state.modalType }
                                ></SocialReasonModal>
                            }
                        </div>
                        { !this.state.activeLoader &&
                            <div style={{ display: "flex", flexDirection: "column", position: "relative", alignItems: "center" }}>
                                <Row>
                                    <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '1vh' }}>
                                        <h2 style={{ color: '#164289', 'fontWeight': 'bold' }}>Razones sociales: <span style={{ color: '#000000'}}>{this.state.userSelected.nombre}</span></h2>
                                    </Col>
                                </Row>
                                <div className="auth-label"></div>
                                <Row style={{width: '100%'}}>
                                <Col xs={6} md={8} sm={6} lg={8} style={{ marginTop: '0.5vh' }}></Col>
                                <Col xs={6} md={4} sm={6} lg={4} style={{ marginTop: '0.5vh' }}>
                                    <button onClick={this.openModalCreate} className="buttonGreenAdd">
                                        Agregar
                                    </button>
                                </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '3vh' }}>
                                        <div className="user-category-wrapper">
                                            { this.state.socialReasons.length > 0 &&
                                                <div>
                                                    <BootstrapTable
                                                        keyField='_id'
                                                        striped
                                                        hover
                                                        condensed
                                                        data={this.state.socialReasons}
                                                        headerWrapperClasses="title-table"
                                                        options={customOptions}
                                                        columns={columns}
                                                    />
                                                </div>
                                            }
                                            { this.state.socialReasons.length === 0 &&
                                                <div style={{ display: 'block', justifyContent: 'center', alignItems: 'center'}}>
                                                    <Row>
                                                        <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '1vh', marginBottom: '1vh' }}>
                                                            <Card variant="outlined" style={{padding: '8px'}}>
                                                                <h3>Sin razones sociales para este usuario</h3>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            }
                                            <br/>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '3vh' }}>
                                        <button className="modal-buttonNo" onClick={this.onPressReturnUD.bind(this)}>
                                            REGRESAR
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                        }
                        {
							<Snackbar
								open={this.state.showSnackBar}
								autoHideDuration={6000}
								onClose={this.handleCloseAlert}
							>
								<Alert
									onClose={this.handleCloseAlert}
									severity={this.state.severitySnackBar}
								>
									{this.state.textSnackBar}
								</Alert>
							</Snackbar>
						}
                    </center>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
	socialReasons:          state.address_management_reducer.socialReasons,
    actionType:             state.address_management_reducer.actionType,
    socialReasonDetailData: state.address_management_reducer.socialReasonDetailData,
    centros:                state.center_reducer,
	error:                  state.address_management_reducer.error,
});

export default connect(mapStateToProps, {
	getSocialReasons,
    getSocialReasonById,
    updateSocialReason,
    createSocialReason,
    deleteSocialReason
})(SocialReasons);
